export enum BreadCrumbsSize {
  MEDIUM = 'medium',
  LARGE = 'large',
}
